import { Plus } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { FadeUp, Eyebrow } from "@/components/Reveal";

export default function StudioNote() {
  const { t } = useLang();
  return (
    <section data-testid="studio-note" className="border-t border-ink/10 bg-paper py-28 md:py-40">
      <div className="mx-auto max-w-2xl px-5 text-center md:px-0">
        <FadeUp className="flex justify-center"><Eyebrow>{t("studio.eyebrow")}</Eyebrow></FadeUp>
        <FadeUp delay={0.15}>
          <p className="mt-10 font-serif text-2xl leading-[1.4] tracking-tight text-ink md:text-[2rem]">
            {t("studio.body")}
          </p>
        </FadeUp>
        <FadeUp delay={0.3} className="mt-12 flex items-center justify-center gap-2">
          <Plus className="h-3.5 w-3.5 text-cobalt" strokeWidth={2.5} aria-hidden="true" />
          <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-ink/50">{t("studio.sig")}</p>
        </FadeUp>
      </div>
    </section>
  );
}
